import { render, staticRenderFns } from "./AgentProduct.vue?vue&type=template&id=38f18b9f&scoped=true"
import script from "./AgentProduct.vue?vue&type=script&lang=js"
export * from "./AgentProduct.vue?vue&type=script&lang=js"
import style0 from "./AgentProduct.vue?vue&type=style&index=0&id=38f18b9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f18b9f",
  null
  
)

export default component.exports